import { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";

interface LineClampedTooltipProps {
  children: ReactNode;
  tooltipContent?: ReactNode;
  className?: string;
}

export const LineClampedTooltip = ({
  children,
  tooltipContent,
  className = "",
}: LineClampedTooltipProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <div className={`line-clamp-2 ${className}`}>{children}</div>
    </TooltipTrigger>
    <TooltipContent>{tooltipContent || children}</TooltipContent>
  </Tooltip>
);
